module.exports = __webpack_public_path__ + "static/media/BitvoLoginPageBackground.5cb474b1.webp";